<mat-form-field
  appearance="fill"
  floatLabel="always"
  subscriptSizing="dynamic"
  [ngClass]="{
    'rkt-FormField--full-width': isFullWidth
  }"
>
  <mat-label>{{ label }}</mat-label>
  <textarea
    matInput
    [attr.data-testid]="dataTestId"
    [attr.maxlength]="maxLength"
    [formControl]="formControlRef"
    [placeholder]="placeholder"
  ></textarea>
  <mat-error [attr.data-testid]="dataTestId + '-error'">{{ errorMessage }}</mat-error>
</mat-form-field>
